import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

export const GiftWrappingProductShopifyMap =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? {
        [ShopifyStore.IN]: {
          variantId: 'gid://shopify/ProductVariant/40719978790982',
          checkouturl: '', // TODO
        },
        [ShopifyStore.AE]: {
          variantId: 'gid://shopify/ProductVariant/44679292780786',
          checkouturl: '', // TODO
        },
        [ShopifyStore.ROW]: {
          variantId: 'gid://shopify/ProductVariant/40709679317052',
          checkouturl: '', // TODO
        },
        [ShopifyStore.GB]: {
          variantId: 'gid://shopify/ProductVariant/49202716836158',
          checkouturl:
            'https://ultrahuman-eu-uk.myshopify.com/cart/49202716836158:1?channel=buy_button',
        },
        [ShopifyStore.EU]: {
          variantId: 'gid://shopify/ProductVariant/49202716836158',
          checkouturl:
            'https://ultrahuman-eu-uk.myshopify.com/cart/49202716836158:1?channel=buy_button',
        },
        [ShopifyStore.US]: {
          //change later
          variantId: 'gid://shopify/ProductVariant/40200417050720',
          checkouturl:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40200417050720:1?channel=buy_button', // TODO
        },
        [ShopifyStore.AU]: {
          variantId: 'gid://shopify/ProductVariant/49202716836158',
          checkouturl:
            'https://ultrahuman-eu-uk.myshopify.com/cart/49202716836158:1?channel=buy_button',
        },
        [ShopifyStore.CA]: {
          //change later
          variantId: 'gid://shopify/ProductVariant/40200417050720',
          checkouturl:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40200417050720:1?channel=buy_button', // TODO
        },
        [ShopifyStore.SA]: {
          variantId: 'gid://shopify/ProductVariant/49202716836158',
          checkouturl:
            'https://ultrahuman-eu-uk.myshopify.com/cart/49202716836158:1?channel=buy_button',
        },
        [ShopifyStore.MX]: {
          variantId: 'gid://shopify/ProductVariant/49202716836158',
          checkouturl:
            'https://ultrahuman-eu-uk.myshopify.com/cart/49202716836158:1?channel=buy_button',
        },
        [ShopifyStore.ZA]: {
          variantId: 'gid://shopify/ProductVariant/49202716836158',
          checkouturl:
            'https://ultrahuman-eu-uk.myshopify.com/cart/49202716836158:1?channel=buy_button',
        },
        [ShopifyStore.JP]: {
          variantId: 'gid://shopify/ProductVariant/49202716836158',
          checkouturl:
            'https://ultrahuman-eu-uk.myshopify.com/cart/49202716836158:1?channel=buy_button',
        },
      }
    : {
        [ShopifyStore.IN]: {
          variantId: 'gid://shopify/ProductVariant/40620990726217',
          checkouturl: '', // TODO
        },
        [ShopifyStore.AE]: {
          variantId: 'gid://shopify/ProductVariant/40620990726217',
          checkouturl: '', // TODO
        },
        [ShopifyStore.ROW]: {
          variantId: 'gid://shopify/ProductVariant/40620990726217',
          checkouturl: '', // TODO
        },
        [ShopifyStore.US]: {
          //change
          variantId: 'gid://shopify/ProductVariant/40200417050720',
          checkouturl:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40200417050720:1?channel=buy_button', // TODO
        },
        [ShopifyStore.SA]: {
          variantId: 'gid://shopify/ProductVariant/49202716836158',
          checkouturl:
            'https://ultrahuman-eu-uk.myshopify.com/cart/49202716836158:1?channel=buy_button',
        },
        [ShopifyStore.MX]: {
          variantId: 'gid://shopify/ProductVariant/49202716836158',
          checkouturl:
            'https://ultrahuman-eu-uk.myshopify.com/cart/49202716836158:1?channel=buy_button',
        },
        [ShopifyStore.EU]: {
          variantId: 'gid://shopify/ProductVariant/49202716836158',
          checkouturl:
            'https://ultrahuman-eu-uk.myshopify.com/cart/49202716836158:1?channel=buy_button',
        },
        [ShopifyStore.GB]: {
          variantId: 'gid://shopify/ProductVariant/49202716836158',
          checkouturl:
            'https://ultrahuman-eu-uk.myshopify.com/cart/49202716836158:1?channel=buy_button',
        },
        [ShopifyStore.AU]: {
          variantId: 'gid://shopify/ProductVariant/49202716836158',
          checkouturl:
            'https://ultrahuman-eu-uk.myshopify.com/cart/49202716836158:1?channel=buy_button',
        },
        [ShopifyStore.CA]: {
          //change later
          variantId: 'gid://shopify/ProductVariant/40200417050720',
          checkouturl:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40200417050720:1?channel=buy_button', // TODO
        },
        [ShopifyStore.ZA]: {
          //change later
          variantId: 'gid://shopify/ProductVariant/40200417050720',
          checkouturl:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40200417050720:1?channel=buy_button', // TODO
        },
        [ShopifyStore.JP]: {
          //change later
          variantId: 'gid://shopify/ProductVariant/40200417050720',
          checkouturl:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40200417050720:1?channel=buy_button', // TODO
        },
      };
